$(document).ready(function() {
  var lazyLoadInstance = new LazyLoad({
    // Your custom settings go here
  });
// $('.custom-made-product-slider').slick();

$('.custom-made-product-slider').slick({
  autoplay:true,
  autoplaySpeed: 2000,
  infinite: true,
  lazyLoad: 'ondemand'
});
// calendly bubble disabled for now
//   var position = 0; 

//   // should start at 0

//   $(window).scroll(function() {
//       var scroll = $(window).scrollTop();
//       if (scroll > position) {
//         if(!$('#calendly-button-app-embed').hasClass('hovered')){
//           $('#calendly-button-app-embed').addClass('scrolled-icon')
//           $('#calendly-button-app-embed').html('<i class="fa-regular fa-calendar-plus"></i>');
//         }
//       else {
//         if(!$('#calendly-button-app-embed').hasClass('hovered')){
//         $('#calendly-button-app-embed').addClass('scrolled-icon')
//         $('#calendly-button-app-embed').html('<i class="fa-regular fa-calendar-plus"></i>');
//         }
//       }
//     }
//       position = scroll;
//   });

// $('#calendly-button-app-embed').mouseenter(function () {
//   $('#calendly-button-app-embed').html('Schedule a Meeting with Sales Team');
//   $('#calendly-button-app-embed').addClass('hovered');
//   $('#calendly-button-app-embed').removeClass('scrolled-icon');
// });

// $('#calendly-button-app-embed').mouseleave(function () {
//   $('#calendly-button-app-embed').html('<i class="fa-regular fa-calendar-plus"></i>');
//   $('#calendly-button-app-embed').addClass('scrolled-icon');
//   $('#calendly-button-app-embed').removeClass('hovered');
// });

  const urlParams = new URLSearchParams(window.location.search);
  
  if (urlParams.get('contact_posted') === 'true') {
      $('#confimation-modal').fadeIn(200).addClass('modal-open');
  }

var $modal = $('#request-quote-modal');

$('.request-for-quote-btn').click(function(){
  
  $('#request-quote-modal').fadeIn(200).addClass('modal-open');
  var productName = $(this).data('product-title');
  var productImage = $(this).data('product-image');
  var productAlt = $(this).data('product-alt');
  var productLink = $(this).data('product-link');
  var productId = $(this).data('product-id');
  // var encodedProdName = encodeURIComponent(productName);
  // var getReturnTo = $('input[name="return_to"]').val();
  // $('input[name="return_to"]').val(getReturnTo+'?prodId='+productId);
  
  $('#request-quote-modal #ContactForm-ProductName').text(productName).val(productName);
  $('#request-quote-modal .modal-product-name h3').text(productName);
  $('#request-quote-modal .modal-product-image-main').attr('data-src', productImage);
  $('#request-quote-modal .product_link').attr('href', productLink);
  lazyLoadInstance.update();
});
$('#request-quote-modal .modal-close-btn').click(function(){
  $('#request-quote-modal').fadeOut(200).removeClass('modal-open');
  $('#request-quote-modal .modal-product-image-main').removeAttr('src').removeAttr('data-ll-status').removeClass('entered loaded');
});

$('#confimation-modal .modal-close-btn').click(function(){
  $('#confimation-modal').fadeOut(200).removeClass('modal-open');
});

  $('img').each(function(index) {
  var $img = $(this);
  var alt = $img.attr('alt');
  var link = $img.attr('src');
  if (alt === undefined) {
    $img.addClass('no-alt');
    console.log(index, 'Image has NO alt attribute', link);
  } else if (alt === '') {
    $img.addClass('no-alt');
    console.log(index, 'Image has alt attribute but alt text is empty', link);
  }
});
// Close when clicking outside modal dialog (on overlay)
$modal.on('click', function(e){
  if ($(e.target).is('.modal-overlay')) {
    $modal.fadeOut(200).removeClass('modal-open');
    $('#request-quote-modal .modal-product-image-main').removeAttr('src').removeAttr('data-ll-status').removeClass('entered loaded');
  }
});

// Optional: close on ESC key
$(document).on('keydown', function(e){
  if (e.key === "Escape") {
    $modal.fadeOut(200).removeClass('modal-open');
    $('#request-quote-modal .modal-product-image-main').removeAttr('src').removeAttr('data-ll-status').removeClass('entered loaded');
  }
});

  $('#cart-icon-bubble').click(function(){
    window.location.href = "https://housesensationsart.com/cart";
  });
});

